export const MIN_POST_TEXT_LENGTH = 12;
